/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate the maturity value of a fixed deposit. Enter your deposit amount, the annual interest rate and the tenure in years.`)
};

const es_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el valor de vencimiento de un depósito fijo. Ingresa tu monto de depósito, la tasa de interés anual y el plazo en años.`)
};

const de_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie den Fälligkeitswert eines Festgeldes. Geben Sie Ihren Einzahlungsbetrag, den jährlichen Zinsatz und die Laufzeit in Jahren ein.`)
};

const nl_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat de waarde van een vaste storting bij afloop. Voer uw stortingsbedrag, het jaarlijkse rentepercentage en de periode in jaren in.`)
};

const fr_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez la valeur à maturité d'un dépôt fixe. Entrez votre montant de dépôt, le taux d'intérêt annuel et la durée en années.`)
};

const it_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il valore a scadenza di un deposito fisso. Inserisci l'importo del tuo deposito, il tasso di interesse annuale e la durata in anni.`)
};

const pt_br2_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor de vencimento de um depósito fixo. Digite seu valor de depósito, a taxa de juros anual e o prazo em anos.`)
};

const pt_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor de maturidade de um depósito fixo. Introduza o seu montante de depósito, a taxa de juro anual e o prazo em anos.`)
};

const ja_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期預金の満期価値を推定します。預金額、年利率、満期年数を入力してください。`)
};

const zh_sip_fd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`估算定期存款的到期价值。输入您的存款金额、年利率和投资期限。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_intro", locale)
	if (locale === "en") return en_sip_fd_intro(inputs)
	if (locale === "es") return es_sip_fd_intro(inputs)
	if (locale === "de") return de_sip_fd_intro(inputs)
	if (locale === "nl") return nl_sip_fd_intro(inputs)
	if (locale === "fr") return fr_sip_fd_intro(inputs)
	if (locale === "it") return it_sip_fd_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_intro(inputs)
	if (locale === "pt") return pt_sip_fd_intro(inputs)
	if (locale === "ja") return ja_sip_fd_intro(inputs)
	return zh_sip_fd_intro(inputs)
};